// extracted by mini-css-extract-plugin
export default {"zr-icon-button":"IconButton_zr-icon-button__6g1MN"};